import { EInterventionType } from "src/app/domain/planning/enum/intervention-type"
import { EGroupementPrelevementAnalyse } from "src/app/domain/Shared/enum/groupement-prelevement-analyse";

export class InterventionCreateDTO {

    Type: EInterventionType
    SampleCode: string
    StationName: string;
    // SamplingPointCode: string
    // GroupementPrelevement: boolean
    GroupementAnalyse: EGroupementPrelevementAnalyse
    ResponsiblePuid: string;
    SamplerPuid: string;
    // DateRenduClient: Date
    // IsInSituMandatory: boolean
    // PhysChimieSampleCode: string
    // PrelEauIntegreSampleCode: string
    // PrelEauPonctuelSampleCodes: string[] = []
    // PrelSedimentSampleCode: string
    // PrelPhytoSampleCode: string
}